import { render } from "./App.vue?vue&type=template&id=bf649a88"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import _style_0 from "./App.vue?vue&type=style&index=0&id=bf649a88&inline&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__